export default class User {
  public givenName: string
  public sn: string
  public displayName: string
  public description: string
  public mail: string
  public sAMAccountName: string
  public userPrincipalName: string
  public End_date: string
  public password: string
  public hasWifi: boolean
  public hasResetPassword: boolean

  constructor(
    givenName: string,
    sn: string,
    displayName: string,
    description: string,
    mail: string,
    sAMAccountName: string,
    userPrincipalName: string,
    end_date: string,
    hasWifi: boolean,
    hasResetPassword: boolean,
  ) {
    this.givenName = givenName
    this.sn = sn
    this.displayName = displayName
    this.description = description
    this.mail = mail
    this.sAMAccountName = sAMAccountName
    this.userPrincipalName = userPrincipalName
    this.End_date = end_date
    this.hasWifi = hasWifi
    this.hasResetPassword = hasResetPassword
  }
}
